import React, { PureComponent } from 'react';
import Validator from 'validatorjs';
import { Button, Form, Modal } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import { TheError } from '../../../../shared/responses/TheResult';

const motivos = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Comprobantes emitidos con errores con relación.',
    value: '01',
  },
  {
    label: 'Comprobantes emitidos con errores sin relación.',
    value: '02',
  },
  {
    label: 'No se llevó a cabo la operación.',
    value: '03',
  },
  {
    label: 'Operación nominativa relacionada en una factura global.',
    value: '04',
  },
];

class ComprobanteCancellationModal extends PureComponent {
  state = {
    data: {
      motivo: '',
    },
    isValid: false,
  };

  get rules() {
    const { data } = this.state;

    const uuidRule = data.motivo === '01' ? 'required' : null;

    return {
      motivo: ['required'],
      uuid_sustitucion: uuidRule ? [uuidRule, 'uuid'] : [],
    };
  }

  handleClose = () => {
    this.props.onClose(false);
  };

  handleSubmit = async (action) => {
    this.setState({
      busy: true,
    });

    const {
      data: { bloquear_ticket, ...rest },
    } = this.state;

    const result = await this.props.cancel(null, {
      uuid: this.props.data.uuid,
      ...rest,
      metadata: {
        bloquear_ticket,
      },
    });

    this.setState({
      busy: false,
    });

    if (!!result) {
      this.props.onClose(true);
    }
  };

  handleOnChange = (value) => {
    let newData = {
      ...this.state.data,
      ...value,
    };

    newData = {
      ...newData,
      uuid_sustitucion: newData.motivo !== '01' ? undefined : newData.uuid_sustitucion,
    };

    this.setState(
      {
        ...this.state,
        data: newData,
      },
      () => {
        const validator = new Validator(newData, this.rules);

        validator.check();

        this.setState({
          ...this.state,
          validator: validator,
          isValid: new Validator(newData, this.rules).passes(),
        });
      }
    );
  };

  render() {
    const rules = this.rules;
    const { data, busy, isValid } = this.state;
    const { error } = this.props.comprobante;

    const isAutofacturacion = [4, 5].includes(this.props.data.clasificacion);

    return (
      <Modal show={true}>
        <Modal.Body>
          <br />
          Al momento de realizar la cancelación se deberá indicar los motivos de la cancelación conforme a las
          siguientes claves:
          <br />
          <br />
          <ul>
            <li>"01" Comprobantes emitidos con errores con relación.</li>
            <li>"02" Comprobantes emitidos con errores sin relación.</li>
            <li>"03" No se llevó a cabo la operación.</li>
            <li>"04" Operación nominativa relacionada en una factura global.</li>
          </ul>
          <a
            target="_blank"
            href="https://www.sat.gob.mx/cs/Satellite?blobcol=urldata&blobkey=id&blobtable=MungoBlobs&blobwhere=1461175074256&ssbinary=true"
            rel="noopener noreferrer"
          >
            Ver más detalles
          </a>
          <br />
          <br />
          <Form autoComplete="off">
            <FormControl
              type="select"
              label="Motivo"
              name="motivo"
              placeholder=""
              help="Motivo de cancelación"
              rules={rules.motivo}
              value={data.motivo}
              options={motivos}
              onChange={this.handleOnChange}
            />

            <FormControl
              type="text"
              label="Folio Fiscal"
              name="uuid_sustitucion"
              placeholder=""
              readOnly={data.motivo !== '01'}
              rules={rules.uuid_sustitucion}
              help="Folio fiscal que sustituye al folio fiscal del que se solicita la cancelación"
              value={data.uuid_sustitucion}
              onChange={this.handleOnChange}
            />

            {isAutofacturacion && (
              <>
                <p>
                  <strong>Portal On-Demand</strong>
                </p>
                <FormControl
                  type="checkbox"
                  id="bloquear_ticket"
                  name="bloquear_ticket"
                  label="Bloquear el ticket?"
                  help="El ticket no podrá ser facturado en el portal de On-Demand"
                  value={data.bloquear_ticket}
                  onChange={this.handleOnChange}
                />
              </>
            )}
          </Form>
          En caso de realizar la sustitución del comprobante, se deberá señalar la clave "01" Comprobantes emitidos con
          errores con relación, así como, manifestar el folio fiscal del comprobante que lo sustituye.
          {!!error && (
            <>
              <br />
              <br />
              <TheError error={error} />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={this.handleClose}
          >
            No quiero cancelar
          </Button>
          <LoadingButton
            variant="primary"
            loading={busy}
            disabled={busy || !isValid}
            onClick={this.handleSubmit}
          >
            Solicitar cancelación
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ComprobanteCancellationModal;
